import { LitElement, html, css } from '@hh/global.js'

class HHInputWrapper extends LitElement {
  static properties = {
    animation: {},
    focused: {
      reflect: true,
    },
    filled: {
      reflect: true,
    },
    label: {},
    disabled: {
      type: Boolean
    },
    hideLabel: {
      type: Boolean
    }
  }

  constructor() {
    super()

    this.onKeyPressBirthday = this.onKeyPressBirthday.bind(this)
    this.onInputBirthday = this.onInputBirthday.bind(this)
    this.onChangeBirthday = this.onChangeBirthday.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()

    this.$select = this.querySelector(`select[slot='input']`)
    this.$select && this.preselectSelectValue()

    this.$birthday = null
    if (this.querySelector(`[slot='input']`).getAttribute('birthday')) {
      this.$birthday = this.querySelector(`[slot='input']`)
      this.$birthday.addEventListener('input', this.onInputBirthday)
      this.$birthday.addEventListener('change', this.onChangeBirthday)
      this.$birthday.addEventListener('keypress', this.onKeyPressBirthday)
    }

    if ((!!this.querySelector(`[slot='input']`).value || this.querySelector(`[slot='input']`).getAttribute('placeholder') !== '') && !this.$select) {
      this.filled = true
    }

    if (this.$select && this.label !== 'stacked') {
      this.filled = true
    }
  }

  preselectSelectValue() {
    if (this.$select?.dataset?.default) {
      this.$select.value = this.$select?.dataset?.default
    }
  }

  onInputBirthday(evt) {
    if (this.$birthday.value.length === 2 && evt.inputType === 'insertText') {
      this.$birthday.value = this.$birthday.value + '/'
    }
  }

  onChangeBirthday(e) {
    const re = new RegExp("(?:0[1-9]|1[0-2])/(?:0[1-9]|[12][0-9]|3[01])")
    const field = this.$birthday.closest('.js-field')
    const error = field.querySelector('.js-error__required')
    if (re.test(e.target.value)) {
      error.classList.remove('shown')
      error.classList.add('hidden')
      field.classList.remove('form-wrapper__with-errors')
    } else {
      field.classList.add('form-wrapper__with-errors')
      error.classList.remove('hidden')
      error.classList.add('shown')
    }
  }

  onKeyPressBirthday(evt) {
    const key = (evt.which) ? evt.which : evt.keyCode
    if (key === 47) {
      if (this.$birthday.value.length !== 2) {
        evt.preventDefault()
      }
    } else if (key > 31 && (key < 48 || key > 57)) {
      evt.preventDefault()
    }
  }

  onChange(e) {
    if (this.animation === 'none' || this.label === 'stacked') {
      return
    }
    this.filled = !!e.target.value
    if (e.target.getAttribute('placeholder') !== '') {
      this.filled = true
    }
  }

  onFocus(e) {
    if (this.animation === 'none') {
      return
    }
    this.focused = true
  }

  onFocusOut(e) {
    if (this.animation === 'none') {
      return
    }
    this.focused = false
  }

  render() {
    const include_textarea = this.querySelector('textarea')
    return html`
      <div class="container ${this.disabled && 'disabled'} ${include_textarea && 'textarea'}">
        <slot name="label"></slot>
        <slot name="icon"></slot>
        <slot
          name="input"
          @change="${this.onChange}"
          @keydown="${this.onChange}"
          @focusin="${this.onFocus}"
          @focusout="${this.onFocusOut}"
        ></slot>
        <slot name="limit"></slot>
      </div>
    `
  }

  static styles = css`
    :host {
      position: relative;
      display: block;
      height: calc(var(--hh-height, 4.5rem) + 0.2rem);
    }

    @media screen and (min-width: 990px) {
      :host {
        height: max(calc(50 / var(--screen-size) * 100vw), 5rem);
      }
    }

    :host(:not([focused=true]).error) {
      border-bottom: 0.1rem solid var(--hh-color-danger);
    }

    .disabled {
      pointer-events: none;
    }

    .textarea {
      padding: 0;
      background-color: var(--hh-color-light);
    }

    ::slotted(label) {
      position: absolute;
      height: var(--hh-height, 5rem);
      padding-left: var(--hh-left-indent-small, 10px);
      transform: translateY(0);
      transition: transform var(--hh-duration-default, 300ms),
        font-size var(--hh-duration-default, 300ms);
      color: var(--hh-color-subdued);
      z-index: 3;
      font: var(--hh-body-caption);
      line-height: var(--hh-height, 5rem);
    }

    ::slotted(span) {
      position: absolute;
      height: var(--hh-height, 5rem);
      right: 1rem;
      color: var(--hh-color-subdued);
      z-index: 3;
      font: var(--hh-body-caption);
      line-height: var(--hh-height, 5rem);
      pointer-events: none;
    }

    .textarea ::slotted(label) {
      height: fit-content;
      line-height: inherit;
      transition: unset;
      transform: unset;
      padding-top: var(--hh-spacing-xs);
      display: block;
      width: auto;
    }

    @media screen and (min-width: 990px) {
      ::slotted(label) {
        height: max(calc(50 / var(--screen-size) * 100vw), 5rem);
        line-height: max(calc(50 / var(--screen-size) * 100vw), 5rem);
      }

      .textarea ::slotted(label) {
        height: fit-content;
        line-height: inherit;
        padding-top: max(calc(10 / var(--screen-size) * 100vw), 1rem);
      }

      ::slotted(span) {
        height: max(calc(50 / var(--screen-size) * 100vw), 5rem);
        line-height: max(calc(50 / var(--screen-size) * 100vw), 5rem);
      }
    }

    .container:hover ::slotted(label) {
      color: var(--hh-color-ink);
    }

    .disabled ::slotted(label),
    .disabled ::slotted(input),
    .disabled ::slotted(textarea),
    .disabled ::slotted(select) {
      color: var(--hh-color-neutral);
    }

    ::slotted(label),
    ::slotted(input),
    ::slotted(textarea),
    ::slotted(select) {
      width: 100%;
      height: var(--hh-height, 5rem);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    ::slotted(label) {
      width: auto;
    }

    @media screen and (min-width: 990px) {
      ::slotted(label),
      ::slotted(input),
      ::slotted(textarea),
      ::slotted(select) {
        height: max(calc(50 / var(--screen-size) * 100vw), 5rem);
      }
    }

    ::slotted(input),
    ::slotted(textarea),
    ::slotted(select) {
      z-index: 2;
      text-indent: var(--hh-left-indent-small, 10px);
      color: var(--hh-color-night);
      background: var(--hh-input-background, var(--hh-color-light));
      border: 0;
      padding: 0;
      font: var(--hh-font);
      caret-color: var(--hh-color-night);
      border-radius: 0
    }

    ::slotted(input[type=date]) {
      text-indent: var(--hh-left-indent-small, 5px);
      color: transparent;
      -webkit-appearance: unset;
    }

    :host([focused='true']) ::slotted(input[type=date]),
    :host([filled='true']) ::slotted(input[type=date]) {
      color: var(--hh-color-night);
    }

    ::slotted(input),
    ::slotted(select) {
      height: calc(var(--hh-height, 50px) - var(--hh-top-space, 15px));
      padding-top: var(--hh-top-space, 15px);
    }

    @media screen and (min-width: 990px) {
      ::slotted(input),
      ::slotted(select) {
        height: max(calc(35 / var(--screen-size) * 100vw), 3.5rem);
        padding-top: max(calc(15 / var(--screen-size) * 100vw), 1.5rem);
      }
    }

    ::slotted(select) {
      appearance: none;
    }

    :host([hideLabel='true']) ::slotted(label) {
      display: none;
    }

    :host([focused='true']) ::slotted(label),
    :host([filled='true']) ::slotted(label) {
      transform: translateY(-11px);
    }

    @media screen and (min-width: 990px) {
      :host([focused='true']) ::slotted(label),
      :host([filled='true']) ::slotted(label) {
        transform: translateY(min(calc(0px - 11 / var(--screen-size) * 100vw), -11px));
      }
    }

    :host([focused='true']) .textarea ::slotted(label),
    :host([filled='true']) .textarea ::slotted(label) {
      transform: unset;
    }

    ::slotted(textarea) {
      display: block;
      position: relative;
      text-indent: var(--hh-spacing-xs);
      padding-top: 3.2rem;
    }

    @media screen and (min-width: 990px) {
      ::slotted(textarea) {
        padding-top: calc(max(calc(27 / var(--screen-size) * 100vw), 2.7rem) + 5px);
      }
    }

    :host([animation='disappear'][focused='true']) ::slotted(label),
    :host([animation='disappear'][filled='true']) ::slotted(label) {
      visibility: hidden;
      transform: translateY(0);
    }

    :host([animation='disappear'][focused='true']) .textarea ::slotted(label),
    :host([animation='disappear'][filled='true']) .textarea ::slotted(label) {
      visibility: visible;
      color: var(--hh-focused-color, var(--hh-color-brand-primary))
    }

    :host([type="text"]) {
      height: var(--hh-height, 50px);
    }

    @media screen and (min-width: 990px) {
      :host([type="text"]) {
        height: max(calc(50 / var(--screen-size) * 100vw), 5rem);
      }
    }

    :host {
      background: transparent;
      border: 0;
    }

    :host([theme='minimal']) {
      background: transparent;
      border: none;
      border-bottom: var(--hh-border-size, 1px) solid currentColor;
    }

    :host([label='stacked']) {
      border: none;
      height: auto;
    }

    :host([label='stacked']) ::slotted(label),
    :host([label='stacked']) ::slotted(input),
    :host([label='stacked']) ::slotted(textarea),
    :host([label='stacked']) ::slotted(select) {
      position: relative;
    }

    :host([label='stacked']) ::slotted(label) {
      height: auto;
      display: block;
      font: var(--hh-label-font);
      margin: var(--hh-label-margin);
      padding-left: 0;
    }

    :host([icon='left']) ::slotted(label) {
      padding-left: var(--hh-left-indent, 3.2rem);
    }

    :host([icon='left']) ::slotted(input) {
      text-indent: var(--hh-left-indent, 3.2rem);
    }

    :host([icon='right']) ::slotted(label) {
      padding-right: var(--hh-right-indent, 3.2rem);
    }

    ::slotted([slot='icon']) {
      display: flex;
      position: absolute;
      width: var(--hh-icon-width, 2.3rem);
      height: var(--hh-height, 5rem);
      pointer-events: none;
      z-index: 3;
    }

    :host([icon='right']) ::slotted([slot='icon']) {
      right: var(--hh-icon-right, 1rem);
    }

    :host([height='multiline']),
    ::slotted(textarea) {
      height: var(--hh-multiline-height, 9.2rem);
    }

    @media screen and (min-width: 990px) {
      :host([height='multiline']),
      ::slotted(textarea) {
        height: max(calc(92 / var(--screen-size) * 100vw), 9.2rem);
      }
    }

    :host([height='compact']),
    :host([height='compact']) ::slotted(input),
    :host([height='compact']) ::slotted(label),
    :host([height='compact']) ::slotted([slot='icon']) {
      height: var(--hh-compact-height, 35px);
      padding-top: 0;
    }

    :host([height='compact']) ::slotted(label) {
      line-height: var(--hh-compact-height, 35px);
    }

    @media screen and (min-width: 990px) {
      :host([height='compact']),
      :host([height='compact']) ::slotted(input),
      :host([height='compact']) ::slotted(label),
      :host([height='compact']) ::slotted([slot='icon']) {
        height: max(calc(var(--hh-compact-height-unit, 35) / var(--screen-size) * 100vw), 5rem);
      }

      :host([height='compact']) ::slotted(label) {
        line-height: max(calc(var(--hh-compact-height-unit, 35) / var(--screen-size) * 100vw), 5rem);
      }
    }

    ::slotted(input:disabled),
    ::slotted(select:disabled),
    ::slotted(textarea:disabled),
    .disabled ::slotted([slot='icon']) {
      color: var(--hh-color-neutral);
    }

    ::slotted(textarea) {
      position: relative;
    }
  `
}

customElements.define('hh-input-wrapper', HHInputWrapper)
